import { h } from "preact";
import Card from "../Card";
import { vpDetailsButton, vpPlaylistCard, vpPlaylistImg, vpPlayButton } from "./Playlist.css";
import MenuButton from "../../../icons/MenuButton.svg";
import Image from "../Image";
import { DisplayTypes } from "../../types/Display.interface";
import { PluginItemContentType } from "../../types/PluginItem.interface";
import PlayButton from "../../../icons/PlayButton2.svg";
var Playlist = function (_a) {
    var _b, _c, _d;
    var data = _a.data, onOpenDetailsHandler = _a.onOpenDetailsHandler, onClickPlayHandler = _a.onClickPlayHandler;
    var pluginData = data;
    var itemData = pluginData.content[0];
    var items = (_b = pluginData.content) === null || _b === void 0 ? void 0 : _b.map(function (item) { return [
        item.contentType === PluginItemContentType.VIDEO
            ? DisplayTypes.VIDEO
            : DisplayTypes.IMAGE,
        item.href,
    ]; });
    var title = itemData.title, description = itemData.description;
    return (h("div", { "data-testid": "playlist-plugin" },
        h(Card, { className: vpPlaylistCard, styles: pluginData.styles, flex: true },
            (title || description) && (h("button", { type: "button", onClick: function () { return onOpenDetailsHandler({ title: title, description: description }); }, title: "Details", className: vpDetailsButton },
                h(MenuButton, { fill: (_c = pluginData === null || pluginData === void 0 ? void 0 : pluginData.styles) === null || _c === void 0 ? void 0 : _c.primaryColor, width: "30px", height: "30px" }))),
            h("button", { type: "button", title: "Play", className: vpPlayButton, onClick: function () { return onClickPlayHandler(DisplayTypes.LIST, items); } },
                h(PlayButton, null)),
            h(Image, { className: vpPlaylistImg, style: { borderRadius: (_d = pluginData.styles) === null || _d === void 0 ? void 0 : _d.borderRadius }, item: itemData, onClickPlayHandler: function () { return onClickPlayHandler(DisplayTypes.LIST, items); } }))));
};
export default Playlist;
